module.exports = __webpack_public_path__ + "img/upload_wall_3.6134d604.webp";